import Snappy from '../../../libs/snappy/snappy';

Snappy.Component.RowHeading = class RowHeading extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-row-heading';
	}

	constructor(element) {
		super(element);
	}

	render() {
	}
};



// WEBPACK FOOTER //
// ./components/rowHeading/scripts/rowHeading.js